const config = {
  vuexStorageKeys: [
    'user',
    'sessionToken'
  ],
  initPlugins: [
    'init',
    'vuexStorage',
    'userInit'
  ],
  env: 'app',
  version: '1.0.0',
  cloudUrl: 'https://cloud.water-heater.mokekeji.com'
}
export default config



// WEBPACK FOOTER //
// ./src/configs/default.js